// extracted by mini-css-extract-plugin
export default {"root":"_3Pb-B5RH","spinner":"_2S9bt9mk","rotate":"_11rFdkOa","black":"_2du6YMP-","gray":"_20M_pSzf","white":"_3-o3pxPo"};